import React from 'react';
import * as Sentry from '@sentry/react';
import { Routes, BrowserRouter as Router, Route, Navigate } from 'react-router-dom';

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);
import { ProtectedRoute, GuestRoute, LoginForm, AutoLogin } from '@/auth';
import Home from '../components/Pages/Home';
import Tramite from '../components/Pages/Tramite';
import Dashboard from '../components/Pages/Dashboard';
import Catastral from '../components/Pages/Subtramites/Catastral';
import ATM from '../components/Pages/Subtramites/ATM';
import PlanoMensura from '../components/Pages/Subtramites/PlanoMensura';
import Reserva from '../components/Pages/Subtramites/Reserva';
import PlanoRelevamiento from '../components/Pages/Subtramites/PlanoRelevamiento';
import Municipalidad from '../components/Pages/Subtramites/Municipalidad';
import Vialidad from '../components/Pages/Subtramites/Vialidad';
import Aguas from '../components/Pages/Subtramites/Aguas';
import Expensas from '../components/Pages/Subtramites/Expensas';
import Irrigacion from '../components/Pages/Subtramites/Irrigacion';
import Presupuestos from '../components/Pages/Subtramites/Presupuestos';
import EstudioResultado from '../components/Pages/Subtramites/EstudioResultado';
import Otros from '../components/Pages/Subtramites/Otros';
import { OtrosTramitesPage } from '@/otros-tramites';
import {
  ContabilidadLayout,
  ResumenPage,
  MovimientosPage,
  CobrosPendientesPage,
  EgresosPendientesPage,
  AgrupadoresPage,
  UtilidadPage,
  SociosPage,
  CajasPage,
} from '@/contabilidad';
import {
  PresupuestosLayout,
  PresupuestosListPage,
  PresupuestoDetallePage,
  PlantillasPage,
  PlantillaDetallePage,
  PRESUPUESTOS_ROUTES,
} from '@/presupuestos';
import { TareasBasePage, TRAMITE_TAREAS_ROUTES } from '@/tramite-tareas';
import Pendientes from '../components/Pages/Pendientes';
import HistorialCambios from '../components/Pages/HistorialCambios';
import Registro from '../components/Pages/Registro';
import GroupOfPeople from '../components/Pages/GroupOfPeople';
import NewGroup from '../components/Pages/GroupOfPeople/NewGroup';
import EditGroup from '../components/Pages/GroupOfPeople/EditGroup';
import ViewGroup from '../components/Pages/GroupOfPeople/ViewGroup';
import UserManagement from '../components/Pages/UserManagement';
import UserProfile from '../components/Pages/UserProfile';
import RolesPermissions from '../components/Pages/RolesPermissions';
import SystemConfiguration from '../components/Pages/SystemConfiguration';
import WhatsAppQueue from '../components/Pages/WhatsAppQueue';
import TemporaryLinksPage from '../components/Pages/TemporaryLinks';
import TramiteReady from '@/auth/components/TramiteReady';


const AppRoutes = () => {
  return (
    <Router>
      <SentryRoutes>
        <Route path="/login" element={<GuestRoute component={LoginForm} redirectTo="/" />} />
        <Route path="/autologin" element={<AutoLogin />} />

        <Route path="/" element={<ProtectedRoute component={Home} />} />
        <Route path="/perfil" element={<ProtectedRoute component={UserProfile} />} />
        <Route path="/usuarios" element={<ProtectedRoute component={UserManagement} permissions={["MANAGE_USERS"]} />} />
        <Route path="/roles-permisos" element={<ProtectedRoute component={RolesPermissions} permissions={["MANAGE_AUTHORIZATION"]} />} />
        <Route path="/configuracion-sistema" element={<ProtectedRoute component={SystemConfiguration} permissions={["MANAGE_SYSTEM_CONFIGURATION"]} />} />
        <Route
          path="/whatsapp-cola"
          element={<ProtectedRoute component={WhatsAppQueue} permissions={["SEND_WHATSAPP", "VIEW_WHATSAPP_DISPATCHES"]} requireAny />}
        />
        <Route path="/enlaces-temporales" element={<ProtectedRoute component={TemporaryLinksPage} permissions={["VIEW_TEMPORARY_LINKS"]} />} />
        <Route path="/registro" element={<ProtectedRoute component={Registro} permissions={["MANAGE_USERS"]} />} />

        <Route path="/grupo-personas" element={<ProtectedRoute component={GroupOfPeople} permissions={["MANAGE_USERS"]} />} />
        <Route path="/crear-grupo-personas" element={<ProtectedRoute component={NewGroup} permissions={["MANAGE_USERS"]} />} />
        <Route path="/editar-grupo-personas" element={<ProtectedRoute component={EditGroup} permissions={["MANAGE_USERS"]} />} />
        <Route path="/ver-grupo-personas" element={<ProtectedRoute component={ViewGroup} permissions={["MANAGE_USERS"]} />} />

        <Route path="/historial" element={<ProtectedRoute component={HistorialCambios} />} />

        <Route path="/tramite" element={<ProtectedRoute component={Tramite} />} />


        <Route element={<TramiteReady />}>
          <Route path="/dashboard" element={<ProtectedRoute component={Dashboard} />} />
          {/* CERTIFICADOS */}
          <Route path="/catastral" element={<ProtectedRoute component={Catastral} permissions={["VIEW_CERTIFICADOS_FILES"]} />} />
          <Route path="/reserva" element={<ProtectedRoute component={Reserva} permissions={["VIEW_CERTIFICADOS_FILES"]} />} />
          {/* FIN CERTIFICADOS */}

          {/* PLANOS */}
          <Route path="/planomensura" element={<ProtectedRoute component={PlanoMensura} permissions={["VIEW_PLANOS_FILES"]} />} />
          <Route path="/planorelevamiento" element={<ProtectedRoute component={PlanoRelevamiento} permissions={["VIEW_PLANOS_FILES"]} />} />
          {/* FIN PLANOS */}


          {/* TRAMITES  */}
          <Route path="/atm" element={<ProtectedRoute component={ATM} permissions={["VIEW_TRAMITES_FILES"]} />} />
          <Route path="/municipalidad" element={<ProtectedRoute component={Municipalidad} permissions={["VIEW_TRAMITES_FILES"]} />} />
          <Route path="/vialidad" element={<ProtectedRoute component={Vialidad} permissions={["VIEW_TRAMITES_FILES"]} />} />
          <Route path="/aguas" element={<ProtectedRoute component={Aguas} permissions={["VIEW_TRAMITES_FILES"]} />} />
          <Route path="/expensas" element={<ProtectedRoute component={Expensas} permissions={["VIEW_TRAMITES_FILES"]} />} />
          <Route path="/irrigacion" element={<ProtectedRoute component={Irrigacion} permissions={["VIEW_TRAMITES_FILES"]} />} />
          {/* FIN TRAMITES */}

          <Route path="/otros-tramites" element={<ProtectedRoute component={OtrosTramitesPage} permissions={["MANAGE_TRAMITES"]} />} />

          {/* PRESUPUESTOS */}
          <Route path="/presupuestos"
            element={<ProtectedRoute
              component={Presupuestos}
              permissions={["VIEW_PRESUPUESTOS_FILES"]} />} />
          {/* FIN PRESUPUESTOS */}

          {/* ESTUDIO TITULO */}
          <Route path="/estudiotitulo" element={<ProtectedRoute component={EstudioResultado} permissions={["VIEW_ESTUDIO_TITULO_FILES"]} />} />
          {/* FIN ESTUDIO TITULO */}
          <Route path="/otros" element={<ProtectedRoute component={Otros} />} />
        </Route>
        {/* Presupuestos independientes (sin escritura asociada) */}
        <Route element={<ProtectedRoute component={PresupuestosLayout} permissions={["VIEW_PRESUPUESTOS_PROFORMA", "CREATE_PRESUPUESTOS_PROFORMA"]} requireAny />}>
          <Route path={PRESUPUESTOS_ROUTES.LISTADO} element={<PresupuestosListPage />} />
          <Route
            path={PRESUPUESTOS_ROUTES.PLANTILLAS}
            element={<ProtectedRoute component={PlantillasPage} permissions={["MANAGE_PRESUPUESTOS_BASE"]} />}
          />
          <Route
            path={PRESUPUESTOS_ROUTES.PLANTILLA_DETALLE}
            element={<ProtectedRoute component={PlantillaDetallePage} permissions={["MANAGE_PRESUPUESTOS_BASE"]} />}
          />
          <Route path={PRESUPUESTOS_ROUTES.DETALLE} element={<PresupuestoDetallePage />} />
        </Route>

        {/* Base genérica del checklist de tareas de escrituras */}
        <Route
          path={TRAMITE_TAREAS_ROUTES.BASES}
          element={<ProtectedRoute component={TareasBasePage} permissions={["MANAGE_TRAMITE_TAREAS_BASE"]} />}
        />

        {/* Contabilidad */}
        <Route element={<ProtectedRoute component={ContabilidadLayout} permissions={["CONTABILIDAD_VIEW"]} />}>
          <Route path="/contabilidad"                       element={<ResumenPage />} />
          <Route path="/contabilidad/movimientos"           element={<MovimientosPage />} />
          <Route path="/contabilidad/cobros-pendientes"     element={<CobrosPendientesPage />} />
          <Route path="/contabilidad/egresos-pendientes"    element={<EgresosPendientesPage />} />
          <Route path="/contabilidad/agrupadores"           element={<AgrupadoresPage />} />
          <Route path="/contabilidad/utilidad"              element={<UtilidadPage />} />
          <Route path="/contabilidad/socios"                element={<SociosPage />} />
          <Route path="/contabilidad/cajas"                 element={<CajasPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </SentryRoutes>
    </Router >
  );
}

export default AppRoutes;
